module.exports = __webpack_public_path__ + "static/media/wallet.a7bb9633.svg";